export interface ArticleCommentsHeaderProps {
  amount: number;
}

const ArticleCommentsHeader = ({ amount }: ArticleCommentsHeaderProps) => {
  return (
    <div className="max-w-2xl mx-auto ">
      <div className="flex justify-between items-center my-2">
        <h2 className="text-xl lg:text-xl font-bold text-gray-900 dark:text-white">
          Discussion ({amount})
        </h2>
      </div>
    </div>
  );
};

export default ArticleCommentsHeader;
